import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import {
  TradingEventDetailApiResponse,
  TradingUserMetricsApiResponse,
  LeaderboardApiResponse,
} from '../routes/singleEvent/types/trading-event-api.types';

import { CookiesKeys } from '../enums/cookies-keys.enum';

export const getTradingEventDetailService = (
  eventId: string,
  signal: AbortSignal
): Promise<AxiosResponse<TradingEventDetailApiResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export const getTradingEventUserMetricsService = (
  eventId: string,
  signal: AbortSignal
): Promise<AxiosResponse<TradingUserMetricsApiResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/user-metrics/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

export interface LeaderboardParams {
  page?: number;
  page_size?: number;
}

export const getTradingEventLeaderboardService = (
  eventId: string,
  params: LeaderboardParams,
  signal: AbortSignal
): Promise<AxiosResponse<LeaderboardApiResponse>> => {
  return axios.get(`/api/v1/events/${eventId}/leaderboard/`, {
    signal,
    params,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};
